import { useDispatch } from "react-redux";
import { doctorsApi } from "../api";

export const useInvalidateDoctorsState = () => {
  const dispatch = useDispatch();

  return () => dispatch(doctorsApi.util.invalidateTags([{ type: "Doctors" }]));
};
